<ng-container [formGroup]="drawingForm">
  <div class="card-body">
    <h2>Drawing</h2>
    <div class="form-group col-12">
      <label class="custom_label">Drawing Date</label>
      <mat-form-field appearance="fill" class="input_datepicker" >
        <mat-label> Date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="date">
        <mat-datepicker-toggle matSuffix [for]="picker" ></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <app-validation-error [formGroup]="drawingForm" [controlName]="'date'"></app-validation-error>

    </div>

    <div class="form-group col-12">
     <div class="row">
       <div class="col-9">
         <label class="custom_label">Drawing Type</label>

         <ng-select
           id="type"
           [items]="typeList"
           placeholder="Drawing Type"
           [closeOnSelect]="true"
           formControlName="type"
           bindLabel="name"
         >
         </ng-select>
         <app-validation-error [formGroup]="drawingForm" [controlName]="'type'"></app-validation-error>
       </div>
       <div class="col-3">
         <label for="number" class="custom_label">No.#</label>
         <input type="number" #htmlInputElement id="number" formControlName="number" class="form-control" placeholder="1" name="number">
         <app-validation-error [formGroup]="drawingForm" [controlName]="'number'"></app-validation-error>
       </div>
     </div>
    </div>

<!--    <div class="form-group col-12">-->
<!--      <label  class="custom_label"> Drawings File</label>-->
<!--      <app-attachment [dropZoneId]="'changeOrderDrawingDropZone'" [fileTypes]="appConstants.documentFileTypes" [module_id]="changeOrderModuleId" (callback)="attachmentId($event)"></app-attachment>-->
<!--    </div>-->
    </div>
</ng-container>
